@if (
  {
    activeLang: activeLang$ | async,
    errorMessage: errorMessage$ | async,
    readOnly: readOnly$ | async,
  };
  as data
) {
  <div class="form-group question-container-inner" [formGroup]="questionForm">
    <lib-input-container
      [headLine]="
        question.translations?.list['headLine']
          | translate: data.activeLang : question.structure.headLine
      "
      [description]="
        question.translations?.list['description']
          | translate: data.activeLang : question.structure.description
      "
      [labelPrefix]="questionNumber$ | async"
      [label]="
        question.translations?.list['title']
          | translate: data.activeLang : question.title
      "
      [questionMarkText]="
        question.translations?.list['questionMarkText']
          | translate: data.activeLang : question.structure.questionMarkText
      "
      [helpText]="
        question.translations?.list['helpText']
          | translate: data.activeLang : question.structure.helpText
      "
      [errorText]="data.errorMessage"
      [for]="labelPrefix + question.id"
      [required]="question.validation.required"
      [width]="'full'"
      [requiredTextEnd]="false"
      [id]="labelPrefix + question.id"
      [questionType]="question.type"
    >
      @if (!data.readOnly) {
        <lib-vinnova-radiobuttons
          [labelPrefix]="labelPrefixForRadiobutton()"
          [radiobuttonObjects]="radiobuttonObjects()"
          formControlName="value"
          [error]="!!data.errorMessage"
          [required]="question.validation.required"
          [name]="name"
          [horizontal]="structure.horizontalOptions"
          [labelledBy]="labelPrefix + question.id"
          [showChangeIndicator]="
            showChanges() &&
            previousAnswersService.hasSimpleValueChanged(
              question.id,
              repeaterGroupId,
              value.value
            )
          "
        >
        </lib-vinnova-radiobuttons>
      }
      @if (data.readOnly) {
        @if (readOnly()) {
          <div class="readonly d-flex align-items-center">
            {{ readOnly() }}
          </div>
        }
        @if (!readOnly()) {
          <div
            class="readonly"
            [ngClass]="
              data.readOnly === ReadonlyState.Locked && value.errors?.required
                ? 'invalid'
                : ''
            "
          ></div>
        }
      }
    </lib-input-container>
  </div>
}
